import { useFormik } from "formik";
import { cultivoInitialValues } from "../constants/constants";
import { CultivoForm } from "./cutltivo.form";
import { cultivoValidations } from "../constants/validations";
import { useCultivo } from "../hooks/useCultivo";
import { useState } from "react";
import Swal from "sweetalert2";

const initialValues = cultivoInitialValues;
const validationSchema = cultivoValidations;

export const AgregarCultivo = ({ reload }) => {
  const { saveCultivo } = useCultivo();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    setIsLoading(true);
    try {
      await saveCultivo(values.cultivo, values.envases);
      Swal.fire({
        icon: "success",
        title: "Cultivo creado",
        timer: 1500,
      });
      reload();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const { values, errors, touched, handleChange, setFieldValue, handleSubmit } =
    useFormik({
      onSubmit,
      initialValues,
      validationSchema,
    });

  return (
    <CultivoForm
      values={values}
      errors={errors}
      touched={touched}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      handleSubmit={handleSubmit}
      loading={isLoading}
    />
  );
};
